import { render, staticRenderFns } from "./RequestViewTabObservers.vue?vue&type=template&id=78337444"
import script from "./RequestViewTabObservers.vue?vue&type=script&lang=js"
export * from "./RequestViewTabObservers.vue?vue&type=script&lang=js"
import style0 from "./RequestViewTabObservers.vue?vue&type=style&index=0&id=78337444&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports